import React, { useState } from "react";
import {
  InputProvider,
  useInput,
} from "../components/context/InputGlobal/InputContext";
import Tabs from "../components/context/Tab/App";
import Sidebar from "../components/Sidebar/Sidebar";
import api from "../services/api";
import axios from "axios";
import ExtractionResult from "../components/ExtractionResult/ExtractionResult";
import * as FaIcons from "react-icons/fa";
import { jwtDecode } from "jwt-decode";

export const FaSearchIcon = FaIcons.FaFileUpload as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const FaSearchIconA = FaIcons.FaSearch as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

const OCRPage: React.FC = () => {
  const [file, setFile] = useState<File | null>(null);
  const [response, setResponse] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { inputValue } = useInput();
  let objUserTk: any;
  if (localStorage.getItem("token")) {
    objUserTk = jwtDecode(localStorage.getItem("token") || "") as any;
  } else {
    objUserTk = {};
  }
  const handleSubmit = async (e: any) => {
    e.preventDefault();

    if (!file) {
      alert("Por favor, selecione um arquivo antes de enviar.");
      return;
    }

    setLoading(true);
    setError("");
    setResponse("");

    try {
      const formData = new FormData();
      formData.append("file", file);
      const apiUrl = process.env.REACT_APP_API_URL;
      const response = await axios.post(
        `${apiUrl}/N8N/uploadDocument`,
        formData,
        {
          headers: {
            Authorization: objUserTk.token,
            Appkey: objUserTk.Appkey,
          },
        }
      );

      console.log(response);
      const data = response.data;
      setResponse(data.json);
    } catch (err: any) {
      console.error(err);
      setError("Falha ao processar o documento. " + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="d-flex"
      style={{ minHeight: "100vh", backgroundColor: "#000" }}
    >
      <Sidebar />
      <div
        className="flex-grow-1 p-4"
        style={{
          backgroundColor: "#ffffff",
          borderTopLeftRadius: "40px",
          borderBottomLeftRadius: "40px",
          padding: "32px",
          boxShadow: "0 0 12px rgba(0,0,0,0.05)",
        }}
      >
        <InputProvider>
          <h1
            style={{
              color: "#78E01D",
              fontWeight: "600",
              fontSize: "36px",
              marginBottom: "24px",
            }}
          >
            Solicitar Pesquisa
          </h1>

          <p style={{ fontSize: "16px", marginBottom: "24px", color: "#555" }}>
            Carregue um documento (PDF ou imagem) para extrair automaticamente
            informações importantes. Clique em <strong>“Extrair Dados”</strong>{" "}
            e aguarde alguns instantes para visualizar os resultados.
          </p>

          <div
            style={{
              backgroundColor: "#F9F9F9",
              padding: "24px",
              borderRadius: "8px",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              margin: "0 auto",
            }}
          >
            <form onSubmit={handleSubmit}>
              <label
                htmlFor="fileInput"
                style={{
                  display: "block",
                  fontWeight: "600",
                  marginBottom: "8px",
                }}
              >
                Selecione ou arraste o documento:
              </label>

              <div
                onClick={() => document.getElementById("fileInput")?.click()}
                style={{
                  border: "2px dashed #78E01D",
                  borderRadius: "12px",
                  padding: "20px",
                  textAlign: "center",
                  cursor: "pointer",
                  backgroundColor: "#f9f9f9",
                  color: "#666",
                  marginBottom: "16px",
                  transition: "all 0.3s ease",
                }}
                onDragOver={(e) => e.preventDefault()}
                onDrop={(e) => {
                  e.preventDefault();
                  if (e.dataTransfer.files && e.dataTransfer.files[0]) {
                    setFile(e.dataTransfer.files[0]);
                  }
                }}
              >
                <FaSearchIcon
                  style={{ color: "#78E01D", marginBottom: "8px" }}
                />
                <p style={{ margin: 0 }}>
                  {file ? (
                    <strong style={{ color: "#333" }}>{file.name}</strong>
                  ) : (
                    "Clique ou arraste um arquivo aqui"
                  )}
                </p>
                <small style={{ color: "#999" }}>(PDF, JPG ou PNG)</small>
              </div>

              <input
                id="fileInput"
                type="file"
                accept=".pdf,.jpg,.png"
                onChange={(e) => {
                  if (e.target.files && e.target.files[0]) {
                    setFile(e.target.files[0]);
                  }
                }}
                style={{ display: "none" }}
              />

              <button
                type="submit"
                disabled={!file || loading}
                style={{
                  backgroundColor: "#78E01D",
                  color: "#fff",
                  border: "none",
                  padding: "12px 20px",
                  borderRadius: "8px",
                  cursor: file ? "pointer" : "not-allowed",
                  fontWeight: "600",
                  opacity: file ? 1 : 0.6,
                  width: "100%",
                  transition: "background 0.3s ease",
                }}
              >
                {loading ? "Enviando..." : "Extrair Dados"}
              </button>
            </form>
            {loading && (
              <div
                style={{ marginTop: "16px", fontWeight: "600", color: "#333" }}
              >
                <strong>Processando o documento, aguarde...</strong>
              </div>
            )}
            {error && (
              <div
                style={{
                  marginTop: "16px",
                  color: "#ff4d4f",
                  backgroundColor: "#ffe8e8",
                  padding: "12px",
                  borderRadius: "4px",
                }}
              >
                {error}
              </div>
            )}
            {response && !error && !loading && (
              <ExtractionResult result={response} />
            )}
          </div>
        </InputProvider>
      </div>
    </div>
  );
};

export default OCRPage;
